import React from 'react';
import {motion} from 'framer-motion';
import {config} from '../../config/jewelleryLandingConfig';

const PainCards = () => {
  return (
    <section id="challenges" className="py-24 bg-espresso text-ivory">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          {/* H2 for section */}
          <h2 className="text-4xl md:text-5xl text-champagne mb-6">You do not need a creative department to look like a premium jewellery brand online</h2>
          <p className="text-lg font-light text-ivory/70 max-w-3xl mx-auto">BPA Solutions helps jewellery founders, boutique stores and small ecommerce teams turn basic product references into premium finished images and product video previews, without needing a studio shoot, model booking, editing workflow or in-house creative team.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {config.challenges.map((card, index) => (
            <motion.div
              key={card.id}
              initial={{opacity: 0, y: 20}}
              whileInView={{opacity: 1, y: 0}}
              viewport={{once: true}}
              transition={{delay: index * 0.1}}
              className={`bg-white/5 p-8 border border-white/10 hover:border-mutedGold/50 transition-colors duration-300 ${index === 8 ? 'md:col-span-2 lg:col-span-1' : ''}`}
            >
              {/* H3 for each challenge */}
              <h3 className="font-serif text-xl text-champagne mb-4 leading-snug">{card.problem}</h3>
              <div className="w-12 h-[1px] bg-mutedGold mb-4"></div>
              <p className="text-sm font-light text-ivory/80 mb-3"><strong className="font-medium text-ivory">Solution:</strong> {card.solution}</p>
              <p className="text-sm font-light text-mutedGold"><strong className="font-medium">Benefit:</strong> {card.benefit}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainCards;